<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p31"><span><a href="#/Contents#rp31">GARDEN GREEN SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="22" src="images/45.jpg" width="22"/></span></p>
<p class="normal"><span><i>Use the freshest greens your garden, or grocer, can provide. This soup can be served hot or cold.</i></span></p>
<p class="make"><span>4 first-course servings</span></p>
<p class="hang"><span>4 shallots, sliced</span></p>
<p class="hang"><span>3 cloves garlic, minced</span></p>
<p class="hang"><span>1 teaspoon canola oil</span></p>
<p class="hang"><span>4 cups mixed greens, torn (romaine, red leaf or Boston lettuce, spinach, escarole, or sorrel)</span></p>
<p class="hang"><span>2 cups fat-free milk</span></p>
<p class="hang"><span>1 cup reduced-sodium fat-free chicken broth</span></p>
<p class="hang"><span>¼ cup chopped fresh or 1 tablespoon dried basil leaves</span></p>
<p class="hang"><span>Grated zest of ½ lemon</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Sauté shallots and garlic in oil in large saucepan until tender, about 3 minutes. Add remaining ingredients, except salt, and pepper, and heat to boiling; reduce heat and simmer until greens are wilted, about 5 minutes. Process soup in food processor or blender until smooth; season to taste with salt and pepper.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 81</span></p>
<p class="per1"><span>% calories from fat: 17</span></p>
<p class="per1"><span>Protein (g): 7.3</span></p>
<p class="per1"><span>Carbohydrate (g): 10.4</span></p>
<p class="per1"><span>Fat (g): 1.7</span></p>
<p class="per1"><span>Saturated fat (g): 0.3</span></p>
<p class="per1"><span>Cholesterol (mg): 2.2</span></p>
<p class="per1"><span>Sodium (mg): 123</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.5</span></p>
<p class="per1"><span>Vegetable: 1.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.5</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0213.vue?3f525460